// extracted by mini-css-extract-plugin
module.exports = {"posItemWrapper":"PosItem_posItemWrapper__3Gug0","posItemName":"PosItem_posItemName__2WElr"};